import 'styled-components/macro';
import React from 'react';
import { useTheme, Typography, Button } from '@harver/shared-ui';

import { ContentCard } from '../../components/ContentCard';
import { useContent } from '../../branding/content.context';

interface Props {
    history: {
        push: (path: string) => void;
    };
    calendarEventId: string;
}

export const EmptySlots = ({ history, calendarEventId }: Props): React.ReactElement => {
    const theme = useTheme();
    const { noSlots: LANG } = useContent();

    document.title = LANG.title;

    return (
        <>
            <ContentCard>
                <div
                    css={{
                        textAlign: 'center',
                        margin: `${theme.sizes.xxxLarge} 0`,
                    }}
                >
                    <Typography
                        css={{
                            textAlign: 'center',
                            marginBottom: theme.sizes.large,
                        }}
                        variant="h2"
                    >
                        {LANG.title}
                    </Typography>
                    <Typography
                        css={{
                            textAlign: 'center',
                            marginBottom: theme.sizes.large,
                        }}
                        variant="body2"
                    >
                        {LANG.p1}
                    </Typography>
                    <Button
                        onClick={() => {
                            history.push(`/interview/unavailable?ref=${calendarEventId}`);
                        }}
                        color="primary"
                    >
                        {LANG.btn}
                    </Button>
                </div>
            </ContentCard>
        </>
    );
};
